import { render, staticRenderFns } from "./pretrade-result.vue?vue&type=template&id=723ec0b6&lang=pug"
import script from "./pretrade-result.vue?vue&type=script&lang=js"
export * from "./pretrade-result.vue?vue&type=script&lang=js"
import style0 from "./pretrade-result.vue?vue&type=style&index=0&id=723ec0b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports